/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
export default {
  subscriptionMessage: 'Your WeatherSpork subscription will be charged to your iTunes account, and your subscription will auto-renew when it expires.',
  products: ['monthly'],
  premiumProducts: ['weathersporkbasic'],
  storeStates: {
    REGISTERED: 'registered',
    INVALID: 'invalid',
    VALID: 'valid',
    REQUESTED: 'requested',
    INITIATED: 'initiated',
    APPROVED: 'approved',
    FINISHED: 'finished',
    OWNED: 'owned',
    DOWNLOADING: 'downloading',
    DOWNLOADED: 'downloaded',
  },
  productDurationMapping: {
    monthly: 1,
    weathersporkbasic: 1,
  },
};
